
import { createElement } from "react";
import { createObj } from "../fable-library-js.5.3.0/Util.js";

/**
 * This function changes the order of the input array. Last item replaces children key, then we remove the last item.
 */
export function HtmlHelper_extractByKeyFast(key, arr) {
    const arrNext_ = Array.from(arr);
            for (let i = 0; i < arrNext_.length; i++) {
            if (arrNext_[i][0] === key) {
            const item = arrNext_[i];
            arrNext_[i] = arrNext_[arrNext_.length - 1]; // overwrite with last
            arrNext_.pop(); // remove last
            return [arrNext_, item]; // extracted tuple
            }
        }
        return [arrNext_, null]; // return full arr and None option for children;
}

export function HtmlHelper_createElement(name, props) {
    const matchValue = HtmlHelper_extractByKeyFast("children", props);
    if (matchValue[1] == null) {
        return createElement(name, createObj(matchValue[0]));
    }
    else {
        return createElement(name, createObj(matchValue[0]), ...matchValue[1][1]);
    }
}

//# sourceMappingURL=Html.fs.js.map
